export default __webpack_public_path__ + "media/images/evenement-d49ef08d48c0bace55adc739c63568ca.png";